import LeftArrow from "icons/black.svg"
import NavHome from "icons/nav-home.svg"
import NavMine from "icons/nav-me.svg"
import NavShoppingCart from "icons/nav-shoppingcart.svg"
import router from "next/router"
import { clamp } from "rambdax"
import { useEffect, useRef, useState } from "react"
import { cls } from "reactutils"

export default function QuickNav() {
  const [open, setOpen] = useState(false)
  const [visible, setVisible] = useState(false)
  const navRef = useRef<HTMLDivElement>()
  const lastPos = useRef<[number, number]>([0, 0])
  const startPos = useRef<[number, number]>([0, 0])
  const startTouchPos = useRef<[number, number]>([0, 0])

  const onTouchStart = (e: TouchEvent) => {
    e.stopPropagation()
    const touch = e.touches[0]
    startTouchPos.current = [touch.clientX, touch.clientY]
    startPos.current = lastPos.current
  }

  const onTouchMove = (e: TouchEvent) => {
    e.preventDefault()
    e.stopPropagation()
    const touch = e.touches[0]
    const [touchX, touchY] = startTouchPos.current
    const [startX, startY] = startPos.current
    const deltaX = touch.clientX - touchX
    const deltaY = touch.clientY - touchY
    const newX = clamp(-window.innerWidth + 32 + 54, 0, startX + deltaX)
    const newY = clamp(
      -window.innerHeight + 100 + 54 + 100,
      150,
      startY + deltaY,
    )
    lastPos.current = [newX, newY]
    navRef.current.style.transform = `translate(${newX}px, ${newY}px)`
  }

  useEffect(() => {
    const navEl = navRef.current

    navEl.addEventListener("touchstart", onTouchStart, { passive: true })
    navEl.addEventListener("touchmove", onTouchMove)

    return () => {
      navEl.removeEventListener("touchmove", onTouchMove)
      navEl.removeEventListener("touchstart", onTouchStart)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setTimeout(() => {
      setVisible(open)
    })
  }, [open])

  const goto = (url) => {
    router.push(url)
  }

  return (
    <>
      <div className={cls("container", open && "openNav")} ref={navRef}>
        {!open ? (
          <div className="nav" onClick={() => setOpen(!open)}>
            <div>快速</div>
            <div>导航</div>
          </div>
        ) : (
          <div className={cls("nav-list", visible && "visible")}>
            <div className="icon-box" onClick={() => goto("/")}>
              <div>
                <NavHome />
              </div>
              <div>首页</div>
            </div>
            {/* <div className="icon-box" onClick={() => goto("/category")}>
              <div>
                <NavCatogory />
              </div>
              <div>分类</div>
            </div> */}
            <div className="icon-box" onClick={() => goto("/pages/cart")}>
              <div>
                <NavShoppingCart />
              </div>
              <div>购物车</div>
            </div>
            <div className="icon-box" onClick={() => goto("/mine")}>
              <div>
                <NavMine />
              </div>
              <div>我的</div>
            </div>
            <div className="icon-box last-icon" onClick={() => setOpen(!open)}>
              <div className="arrow-box">
                <LeftArrow />
              </div>
              <div>收起</div>
            </div>
          </div>
        )}
      </div>
      <style jsx>{`
        .container {
          width: 54px;
          height: 54px;
          background: rgba(0, 0, 0);
          border-radius: 27px;
          position: fixed;
          z-index: 9;
          transition: height 0.3s;
          opacity: 0.6;
          bottom: 160px;
          right: 16px;
        }
        .openNav {
          height: calc(330px - 66px);
        }
        .nav {
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          font-size: 14px;
          color: #ffffff;
          line-height: 17px;
          height: 54px;
        }
        .nav-list {
          color: #ffffff;
          font-size: 12px;
          opacity: 0;
        }
        .visible {
          opacity: 1;
          transition: opacity 1s;
        }
        .nav-list :global(svg path) {
          fill: rgba(255, 255, 255, 0.53);
        }
        .icon-box {
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          height: 66px;
          position: relative;
        }
        .icon-box::after {
          content: "";
          width: 24px;
          height: 1px;
          background: #ffffff;
          position: absolute;
          bottom: 0;
        }
        .last-icon::after {
          display: none;
        }
        .arrow-box {
          transform: rotate(-90deg) translateY(3px);
        }
      `}</style>
    </>
  )
}
